exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-group-prepend.after {\n  position: absolute;\n  right: 1.5rem;\n}\n.return {\n  font-size: 0.75rem;\n}\n.return .toggle.btn {\n  max-height: 38px;\n  max-width: 100%;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.return .toggle.btn .toggle-off {\n  color: #aaa !important;\n  font-weight: normal;\n}", ""]);

